import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "LEDService",
  controller: "LED",
};

const methods = [
  "GetLedLayoutList"
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.get(path, data)
        }
    })
};

const LedgetApi = ZJApi.defineNewApi("LedgetApi", factory);

export default LedgetApi;
